// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1526":"1ef94e2b","3039":"14017a05","6534":"ce99d352","7994":"e76888cd"}[chunkId] + ".chunk.css";
};